import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MkpItemEventContainerModel } from '../../../../../models/aggregates/mkp/mkp-item-event-container.model';


@Injectable({
  providedIn: 'root'
})
export class MkpItemEventService extends BaseApiTemplateService<MkpItemEventContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + "item-events/" + Core2Config.BACKOFFICE_EP_SUFFIX;
  readonly endpointPathGeneric = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + "item-events/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpointPathGeneric + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = this.endpointPathGeneric + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}